class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.input.addEventListener(
        'input',
        /*
         * 200 statt Dawns 300: das Debounce steht vor jeder Suche - Wortsuche
         * wie KI - und ist damit der erste Posten jeder Wartezeit. Die Aufrufe
         * dahinter brechen sauber ab bzw. sind gecacht, ein zu früher Aufruf
         * kostet also fast nichts, ein zu später immer 100ms Anzeige.
         */
        debounce((event) => {
          this.onChange(event);
        }, 200).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  onFormSubmit(event) {
    this.quoteTermForExactSearch(event);
  }

  // Once a term has any hit at all, Shopify pads the results page with loosely related
  // products - that is how gluten containing items ended up under "glutenfrei". Quoting
  // the term limits it to actual matches. main-search.liquid falls back to the loose
  // search when the quoted one comes back empty, so typos and partial words still work.
  quoteTermForExactSearch(event) {
    if (event.defaultPrevented || !this.input) return;

    const term = this.input.value.trim();
    // On the search page the form sits inside both <predictive-search> and <main-search>,
    // so each submit runs this twice - leave an already quoted term alone.
    if (!term || (term.startsWith('"') && term.endsWith('"'))) return;

    this.input.value = `"${term.replace(/"/g, '')}"`;
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
